export { InformeWDialog } from './informeWDialog';
